import { Link, useNavigate } from "react-router-dom"
import api from "../../api/api";
import Pagination from "../../Components/Pagination"
import { MyContext } from "../../Components/Context";
import { useContext, useEffect, useState } from "react";
import SearchField from "../../Components/Forms/SearchField";
import Loader from "../../Components/Loader";
import DistributionFond from './Detail';


export default function Distributions() {


    const navigate = useNavigate();

    const [annonces, setAnnonces] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false)
    const [selectedDist, setSelectedDist] = useState({})

    const { actifItem, setActifItem } = useContext(MyContext);

    
    useEffect(() => {
        const getAllAnnonces = async () => {
            setLoading(true);
            try {
                const response = await api.get('/distribution/read', {
                    params: {
                        page: currentPage,
                    }
                });
                setAnnonces(response.data.rows);
                setTotalPages(response.data.count);
                setActifItem('Distributions')
                
            } catch (err) {
                console.error('Erreur lors de la récupération des annonces :', err);
            }
            setLoading(false);
        }
        getAllAnnonces();
    }, [currentPage, search]);

    return (
        <div className="px-4 md:px-8">
            {/* En-tête de la section */}
            <div className="max-w-lg mb-6">
                <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 sm:text-2xl">
                Distributions de fond
                </h3>
                {/* <p className="mt-2 text-gray-600 dark:text-gray-400">Texte optionnel ici...</p> */}
            </div>

            {/* Contenu du tableau ou du loader */}
            <div className="mt-8 overflow-x-auto bg-white shadow-sm dark:bg-gray-800">
                {loading ? (
                <Loader /> 
                ) : annonces.length === 0 ? (
                <div className="flex items-center justify-center h-64 text-center text-gray-600 dark:text-gray-300">
                    <p className="text-xl font-medium">Aucune annonce trouvée.</p>
                </div>
                ) : (
                <table className="w-full text-sm text-left table-auto">
                    <thead className="font-semibold text-gray-600 bg-gray-200 border-b dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300">
                    <tr>
                        <th className="px-6 py-3">Id</th>
                        <th className="px-6 py-3">Pourcentage</th>
                        <th className="px-6 py-3">Propriétaire</th>
                        <th className="px-6 py-3">Prix</th>
                        <th className="px-6 py-3">Paiement ID</th>
                        <th className="px-6 py-3">Status</th>
                        <th className="px-6 py-3">Date</th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700 divide-y divide-gray-200 dark:text-gray-300 dark:divide-gray-600">
                    {annonces.map((item, idx) => (
                        <tr
                        key={idx}
                        className="transition duration-200 ease-in-out cursor-pointer hover:bg-gray-200 hover:text-gray-700 dark:hover:bg-gray-200 dark:hover:text-gray-700"
                        onClick={() => {
                            setSelectedDist(item);
                            setOpen(true);
                        }}
                        >
                        <td className="px-6 py-3 whitespace-nowrap">{item.id}</td>
                        <td className="px-6 py-3 text-green-600 whitespace-nowrap">{item.commission}%</td>
                        <td className="px-6 py-3 whitespace-nowrap">{item.paiement.reservation.annonce.owner.client.firstname}</td>
                        <td className="px-6 py-3 whitespace-nowrap">{item.paiement.reservation.totalprice} XAF</td>
                        <td className="px-6 py-3 whitespace-nowrap">{item.paiement.id}</td>
                        <td className="px-6 py-3 whitespace-nowrap">
                            <span className={`inline-block px-2 py-1 text-xs font-semibold rounded-full ${item.status === 'Completed' ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
                            {item.status}
                            </span>
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                )}
            </div>

            {/* Pagination */}
            {annonces.length > 0 && (
                <div className="mt-6">
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                />
                </div>
            )}

            {/* Modal de distribution */}
            {selectedDist && (
                <DistributionFond open={open} setOpen={setOpen} data={selectedDist} />
            )}
        </div>

    )
}